import api from './api';
import { Product, ApiResponse, PaginationMeta } from '../types';

interface ProductsResponse {
  data: Product[];
  pagination: PaginationMeta;
}

interface ProductFilters {
  category?: string;
  brand?: string;
  minPrice?: number;
  maxPrice?: number;
  requiresPrescription?: boolean;
  inStock?: boolean;
  featured?: boolean;
  sort?: string;
  order?: 'asc' | 'desc';
  page?: number;
  limit?: number;
}

export const productService = {
  getProducts: (filters: ProductFilters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) params.set(key, String(value));
    });
    return api.get<ProductsResponse>(`/products?${params}`);
  },

  search: (q: string, page = 1, limit = 20) =>
    api.get<ApiResponse<{ products: Product[]; categories: { id: string; name: string; slug: string }[]; query: string }>>(`/products/search?q=${encodeURIComponent(q)}&page=${page}&limit=${limit}`),

  getFeatured: () =>
    api.get<ApiResponse<Product[]>>('/products/featured'),

  getBySlug: (slug: string) =>
    api.get<ApiResponse<Product & { related: Product[] }>>(`/products/${slug}`),

  create: (formData: FormData) =>
    api.post<ApiResponse<Product>>('/products', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  update: (id: string, data: FormData | Partial<Product>) =>
    api.put<ApiResponse<Product>>(`/products/${id}`, data,
      data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}
    ),

  delete: (id: string) => api.delete(`/products/${id}`),
};
